/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import { call, join, put, take, takeEvery } from "redux-saga/effects";
import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory, takeLatestByScope } from "Utils/sagaUtils";
import noop from "lodash.noop";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import { CREATE_REQUESTED, createFailed, createSucceeded } from "./addProjectModal.duck";
import { v2CreateProject, v3CreateProject, loadCurrentUser, rolloverUsersToProject } from "./addProjectModal.api";
import { loadAllUsers } from "Contexts/project/dataTypes/users/users.api";
export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        createFailed,
        createSucceeded,
    },
    () => "v3.projectManagement.create"
);

export const withApiContext = injectApiWithContextFactory(
    {
        v2CreateProject,
        v3CreateProject,
        loadCurrentUser,
        rolloverUsersToProject,
    },
    injectBoundGQLClient
);

function* createProjectSaga({
    data,
    api: { v2CreateProject, v3CreateProject, loadCurrentUser, rolloverUsersToProject },
    actions: { createFailed, createSucceeded },
    resolve = noop,
    reject = noop,
    mdContext = {},
}) {
    try {
        const { projectId: legacyId } = yield v2CreateProject({
            projectName: data?.project?.projectname,
            projectOrganisation: mdContext.organisation,
        });
        const { _id: v3ProjectId } = yield v3CreateProject({
            legacyId: legacyId,
            parentId: mdContext.instance,
            projectName: data?.project?.projectname,
        });

        const { firstname, lastname, email, _id } = yield loadCurrentUser();
        
        yield rolloverUsersToProject({
            toProject: data?.project?.projectname,
            users: [{ firstName: firstname, lastName: lastname, email, role: "Administrator" }],
        });
        
        yield call(resolve);
        // Get the current URL
        var url = window.location.href;

        // Replace the value of the CurrentProjectID parameter with a new number (in this example, 10)
        var newUrl = url.replace(/name=\w+/, 'name=DashboardView').replace(/CurrentProjectID\/\d+/, `CurrentProjectID/${legacyId}`);
        
        // Navigate to the new URL
        window.location.href = newUrl;
        window.location.reload();
    } catch (error) {
        yield createFailed(error);
        yield call(reject, error);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(CREATE_REQUESTED, withApiContext(withBoundActions(createProjectSaga)));
    };
